module.exports = __webpack_public_path__ + "static/media/amizone.f83610d5.png";